import { PageLink } from '../../../../../../_metronic/layout/core'
import { DEFAULT_ROLES } from '../../../../../common/core/_consts'
import { ISelectOption, ProviderDirection, TrafficType } from './types'

export const PROVIDER_DIRECTIONS: ISelectOption<ProviderDirection>[] = [
  { value: 'PAYMENT', label: 'Пополнение' },
  { value: 'PAYOUT', label: 'Выплата' },
]

export const TRAFFIC_TYPES: ISelectOption<TrafficType>[] = [
  { value: 'FTD', label: 'Первичный' },
  { value: 'STD', label: 'Вторичный' },
]

export const PROVIDER_MANAGEMENT_BREADCRUMBS: Array<PageLink> = [
  {
    title: 'Менеджер провайдеров',
    path: '/settings/provider-management/providers',
    isSeparator: false,
    isActive: false,
    roles: DEFAULT_ROLES,
  },
]
